module.exports = __webpack_public_path__ + "static/media/Latin-Merriweather-Bold.115f5a1d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather/Latin-Merriweather-Bold.woff2
// module id = 518
// module chunks = 0